<template>
  <ZMainPage :loading="loading || submitLoading" type="card">
    <div class="z-box-bg mb-2">
      <div style="margin-bottom: -22rem;">
        <el-form ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col span="4">
              <el-form-item prop="school_id">
                <el-select v-model="form.school_id" clearable placeholder="筛选校区">
                  <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="4">
              <el-form-item prop="data_type">
                <el-select v-model="form.data_type" clearable placeholder="筛选多元升学业务线">
                  <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="4">
              <el-button type="primary" :loading="submitLoading" @click="handleSubmit">搜索</el-button>
              <el-button :disabled="submitLoading" @click="handleReset">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <template v-if="showType === 'init'">
      <div class="z-box-bg flex-center" style="min-height: calc(100vh - 220rem);">
        <zu-empty text="请选择筛选条件，并搜索" />
      </div>
    </template>
    <template v-else>
      <div v-if="showType === 'business' && list1.length" class="follow-list">
        <div v-for="(item, idx) in list3" :key="idx" class="item">
          <div class="top">
            <div class="info">
              <div class="tips">跟进量</div>
              <div>
                <span class="num">{{ item.value }}/{{ item.total }}</span>
                <span class="txt">（人）</span>
              </div>
            </div>
            <div class="img" />
          </div>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
      <div class="mb-2 board-wrap">
        <div class="board-l board-t">
          <div class="z-box-bg flex-1">
            <div class="board-title">{{ text1 }}</div>
            <div v-if="option1" class="board-content" ref="chart1" />
            <div v-else class="board-content flex-center"><zu-empty /></div>
          </div>
          <div class="z-box-bg flex-1">
            <div class="board-title">{{ text2 }}</div>
            <div v-if="option2" class="board-content" ref="chart2" />
            <div v-else class="board-content flex-center"><zu-empty /></div>
          </div>
        </div>
        <div class="board-r board-t flex-wrap">
          <template v-if="showType === 'business'">
            <div class="z-box-bg flex-1">
              <div class="board-title">{{ text5 }}</div>
              <div v-if="list1.length" class="school-warp board-content">
                <div class="school-list">
                  <div v-for="(item, idx) in list1" :key="idx" class="school-item">
                    <div class="content">
                      <div class="info">
                        <div class="name" :style="{ color: item.color }">{{ item.name }}</div>
                        <div class="num">{{ item.value }}/{{ item.total }}</div>
                      </div>
                      <zu-line-progress :progress="item.progress" :progress-color="item.color" />
                    </div>
                    <div class="progress" :style="{ color: item.color }">{{ item.progress }}%</div>
                  </div>
                </div>
                <div class="school-change">
                  <div>
                    <div class="txt">总转化率</div>
                    <div><span class="num">{{ rate }}</span><span class="rate">%</span></div>
                  </div>
                  <div>
                    <div class="txt">总转化人数</div>
                    <div><span class="num">{{ total }}</span></div>
                  </div>
                </div>
              </div>
              <div v-else class="board-content">
                <zu-empty />
              </div>
            </div>
          </template>
          <template v-else>
            <template v-if="list2.length">
              <div class="z-box-bg rate-box" v-for="(item, idx) in list2" :key="idx">
                <div class="top flex justify-between align-center">
                  <div class="flex align-center">
                    <span class="txt">{{ item.name }}</span>
                    <span class="num">{{ item.progress }}%</span>
                  </div>
                  <zu-circle-progress :progress="item.progress" width="34" />
                </div>
                <div class="bot">
                  <span class="txt">{{ item.desc }}</span>
                  <span class="num">{{ item.value }}/{{ item.total }}</span>
                  <span class="unit">（人）</span>
                </div>
              </div>
            </template>
            <div v-else class="z-box-bg flex-1 flex-center" style="height: 470rem;">
              <zu-empty />
            </div>
          </template>
        </div>
      </div>
      <div class="mb-2 board-wrap">
        <div class="board-l">
          <div class="z-box-bg">
            <div class="board-title text-center">
              <span class="line g" :class="data.data_type === 'yiti' ? 'g' : 'b'">{{ text3 }}</span>
            </div>
            <div v-if="option3" class="chart-box" ref="chart3" />
            <div v-else class="chart-box flex-center"><zu-empty /></div>
          </div>
        </div>
        <div class="board-r">
          <div class="z-box-bg">
            <div class="board-title text-center">
              <span class="line">{{ text4 }}</span>
            </div>
            <div v-if="option4" class="chart-box">
              <div class="chart-box" ref="chart4" />
              <div class="chart-tips">
                <div class="item" v-for="(item, idx) in tips" :key="idx">
                  <div class="c" :style="{ background: item.value }" />
                  <div class="t">{{ item.name }}</div>
                </div>
              </div>
            </div>
            <div v-else class="chart-box flex-center"><zu-empty /></div>
          </div>
        </div>
      </div>
    </template>
  </ZMainPage>
</template>

<script>
import ZuCircleProgress from '@/components/common/ZuCircleProgress'
import ZuLineProgress from '@/components/common/ZuLineProgress'
import ZuEmpty from '@/components/common/ZuEmpty'
import * as eCharts from 'echarts'
import { preciseDivide, preciseMultiply } from '@/utils'
import http from '@/api'
export default {
  _config:{ route: { path: 'list', meta: { title: '列表', keepAlive: true }}},
  components: { ZuCircleProgress, ZuLineProgress, ZuEmpty },
  data() {
    return {
      loading: false,
      submitLoading: false,
      showType: 'init',
      config: { will: {}, level: {}, agree: {} },
      data: {
        school_id: '',
        data_type: '',
      },
      form: {
        school_id: '',
        data_type: '',
      },
      rules: {
        school_id: [{required: false, message: '筛选校区', trigger: 'change'}],
        data_type: [{required: true, message: '筛选多元升学业务线', trigger: 'change'}],
      },
      options1: [],
      options2: [
        { value: 'liuxue', label: '留学' },
        { value: 'yiti', label: '艺体' },
        { value: 'danzhao', label: '单招' }
      ],
      list1: [],
      list2: [],
      list3: [],
      tips: [
        { name: '强关联', value: '#5B70D9' },
        { name: '中关联', value: '#8A9AE4' },
        { name: '弱关联', value: '#C9D0F2' },
        { name: '无关联', value: '#EFF1F7' },
      ],
      total: 0,
      rate: 0,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      option1: null,
      option2: null,
      option3: null,
      option4: null,
      text1: '',
      text2: '',
      text3: '',
      text4: '',
      text5: '',
    }
  },
  beforeDestroy() {
    this.disposeEChart()
  },
  created() {
    this.getConfig()
  },
  methods: {
    initEChart() {
      this.$refs.chart1 && (this.chart1 = eCharts.init(this.$refs.chart1))
      this.$refs.chart2 && (this.chart2 = eCharts.init(this.$refs.chart2))
      this.$refs.chart3 && (this.chart3 = eCharts.init(this.$refs.chart3))
      this.$refs.chart4 && (this.chart4 = eCharts.init(this.$refs.chart4))
      this.$refs.chart5 && (this.chart5 = eCharts.init(this.$refs.chart5))
      this.$refs.chart6 && (this.chart6 = eCharts.init(this.$refs.chart6))
      window.addEventListener('resize', this.resize)
    },
    disposeEChart() {
      window.removeEventListener('resize', this.resize)
      if (this.chart1) {
        eCharts.dispose(this.$refs.chart1)
        this.chart1 = null
      }
      if (this.chart2) {
        eCharts.dispose(this.$refs.chart2)
        this.chart2 = null
      }
      if (this.chart3) {
        eCharts.dispose(this.$refs.chart3)
        this.chart3 = null
      }
      if (this.chart4) {
        eCharts.dispose(this.$refs.chart4)
        this.chart4 = null
      }
      if (this.chart5) {
        eCharts.dispose(this.$refs.chart5)
        this.chart5 = null
      }
      if (this.chart6) {
        eCharts.dispose(this.$refs.chart6)
        this.chart6 = null
      }
    },
    clearEChart() {
      this.option1 = null
      this.option2 = null
      this.option3 = null
      this.option4 = null
      this.list1 = []
      this.list2 = []
      this.list3 = []
      this.total = 0
      this.rate = 0
    },
    resize() {
      if (this.chart1) this.chart1.resize()
      if (this.chart2) this.chart2.resize()
      if (this.chart3) this.chart3.resize()
      if (this.chart4) this.chart4.resize()
      if (this.chart5) this.chart5.resize()
      if (this.chart6) this.chart6.resize()
    },
    getConfig() {
      const obj = { will: {}, level: {}, agree: {} }
      http({ url: '/1v1/sys-config/get', pre: 'api2' }, { key: 'muti_study_follow' }).then(res => {
        this.config = { liuxue: res.liuxue || { ...obj } , yiti: res.yiti || { ...obj }, danzhao: res.danzhao || { ...obj } }
      })
      this.loading = true
      http({ url: '/feedback/problem/school', pre: 'api2' }, { is_entity: 1 }).then(res => {
        if (res && res.length) {
          this.options1 = res.map(item => ({ value: item.school_id, label: item.school_name }))
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getChartData() { 
      this.submitLoading = true
      this.data = { ...this.form }
      this.showType = this.data.school_id ? 'all' : 'business'
      http({ url: '/work/muti-study-follow/data-static', pre: 'api2' }, { ...this.form }).then(res => {
        const cof = this.config[this.data.data_type] || {}
        let option3 = {}, data1 = [], data2 = [], data3 = [], data4 = []
        if (this.data.data_type === 'liuxue') {
          this.text1 = '客户留学意向分布'
          this.text2 = '客户留学意愿分布'
          this.text3 = '客户经济能力与留学意向分析'
          this.text4 = '家长支持度与留学意愿变化关联分析'
          this.text5 = '留学转化率排行榜'
          const a2 = res[this.text2] || []
          const c2 = ['90BE6D', 'F94144', 'F9C74F', '6BE1D5', '2D9CDB']
          data2 = a2.map((i, j) => ({ value: i.level_num, name: cof?.level[i.level] || i.level, itemStyle: { color: '#' + c2[j%5] }}))
          const c3 = ['4BBEEB', '8D72E4', 'FF7777', 'FFBD3D', '6BE1D5']
          let a3 = res[this.text3] || []
          let as = []
          a3.sort((a, b) => b.income - a.income).forEach(i => {
            const name = cof?.income[i.income] || i.income
            const idx = as.findIndex(k => i.income === k.income)
            if (idx < 0) as.push({ name ,income: i.income, type: 'bar', barMaxWidth: 20, barGap: '70%', barCategoryGap: '10%', itemStyle: { borderRadius: [60, 60, 0, 0] }, emphasis: { focus: 'series' }, data: [{ value: i.number, will: i.will }] })
            else as[idx].data.push({ value: i.number, will: i.will })
          })
          data3 = as.map((i, j) => ({ ...i, color: '#' + c3[j%5], data: i.data.sort((a, b) => b.will - a.will) }))
          const names = data3[0].data.map(i => cof?.will[i.will] || i.will)
          option3 = {
            tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }},
            legend: { bottom: '1%', left: 'center' },
            xAxis: {
              axisLine: { show: false },
              axisTick: { show: false },
              splitLine: { show: true, lineStyle: { type: 'dashed', color:'#BDBDBD' }},
              data: names
            },
            yAxis: {
              splitLine: { show: true, lineStyle: { type: 'dashed', color:'#BDBDBD' }}
            },
            series: data3
          }
        } else if (this.data.data_type === 'yiti') {
          this.text1 = '客户艺体意向分布'
          this.text2 = '预计系统学习时间分析'
          this.text3 = '意向艺体方向分析'
          this.text4 = '家长支持度与艺体意愿变化关联分析'
          this.text5 = '艺体转化率排行榜'
          const a2 = res[this.text2] || []
          const c2 = ['90BE6D', 'F94144', 'F9C74F', '6BE1D5', '2D9CDB']
          data2 = a2.map((i, j) => ({ value: i.study_time_num, name: cof?.study_time[i.study_time] || i.study_time, itemStyle: { color: '#' + c2[j%5] }}))
          const a3 = res[this.text3] || []
          const names = a3.map(i => i.yiti_way)
          data3 = a3.map(i => i.yiti_way_num)
          option3 = {
            tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }},
            grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
            xAxis: [
              {
                type: 'category',
                axisLine: { show: false },
                axisTick: { show: false, alignWithLabel: true },
                axisLabel: {
                  show: true,
                  interval: 0,
                  fontSize: 11,
                  lineHeight: 16,
                  formatter: function(params) {
                    let newParamsName = ''   
                    const paramsNameNumber = params.length
                    const provideNumber = 7 // 一行显示几个字
                    const rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                    if (paramsNameNumber > provideNumber) {
                      for (let p = 0; p < rowNumber; p++) {
                        let tempStr = ''
                        const start = p * provideNumber
                        const end = start + provideNumber
                        if (p == rowNumber - 1) {
                          tempStr = params.substring(start, paramsNameNumber)
                        } else {
                          tempStr = params.substring(start, end) + '\n'
                        }
                        newParamsName += tempStr
                      }
                    } else {
                      newParamsName = params
                    }   
                    return newParamsName
                  }
                },
                data: names
              }
            ],
            yAxis: {
              splitLine: { show: true, lineStyle: { type: 'dashed', color:'#BDBDBD' }}
            },
            series: [
              {
                type: 'bar',
                barWidth: '30%',
                barGap: '70%',
                barCategoryGap: '10%',
                itemStyle: {
                  borderRadius: [60, 60, 0, 0],
                  color: function (params) {
                    const arr = ['#4BBEEB', '#8D72E4', '#FF7777', '#FFBD3D', '#6BE1D5']
                    return arr[params.dataIndex%5]
                  }
                },
                data: data3
              }
            ]
          }
        } else if (this.data.data_type === 'danzhao') {
          this.text1 = '客户单招意向分布'
          this.text2 = '客户单招意愿分布'
          this.text3 = '单招家长支持度分析'
          this.text4 = '家长支持度与单招意愿变化关联分析'
          this.text5 = '单招转化率排行榜'
          const a2 = res[this.text2] || []
          const c2 = ['90BE6D', '2D9CDB', '6BE1D5']
          data2 = a2.map((i, j) => ({ value: i.level_num, name: cof?.level[i.level] || i.level, itemStyle: { color: '#' + c2[j%3] }}))
          const a3 = res[this.text3] || []
          const obj = cof.agree || {}
          const names = a3.map(i => obj[i.agree])
          data3 = a3.map(i => i.agree_num)
          option3 = {
            tooltip: { trigger: 'axis', axisPointer: { label: { backgroundColor: '#6a7985' }}},
            xAxis: {
              type: 'category',
              axisLine: { show: false },
              axisTick: { show: false },
              splitLine: { show: true, lineStyle: { type: 'dashed', color:'#BDBDBD' }},
              data: names
            },
            yAxis: { type: 'value', splitLine: { show: true, lineStyle: { type: 'dashed', color:'#BDBDBD' }}},
            series: [
              {
                type: 'line',
                smooth: true,
                showSymbol: false,
                emphasis: { focus: 'series' },
                areaStyle: {
                  opacity: 0.8,
                  color: new eCharts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#5B7FFA' },
                    { offset: 1, color: 'rgba(168,210,255,0)' }
                  ])
                },
                data: data3
              }
            ]
          }
        }
        const c1 = ['FF9046', '4CBDEB', '8D72E4', 'FFBD3D']
        const a1 = res[this.text1] || []
        data1 = a1.map((i, j) => ({ value: i.will_num, name: cof?.will[i.will] || i.will, itemStyle: { color: '#' + c1[j%4] }}))
        const a4 = res[this.text4] || []
        const a4_x = {}, a4_y = {}
        data4 = a4.map(i => {
          if (!a4_x[i[1]]) {
            a4_x[i[1]] = cof.agree[i[1]] || '-'
          }
          if (!a4_y[i[0]]) {
            a4_y[i[0]] = cof.level[i[0]] || '-'
          }
          return [i[1], i[0], i[2] || '-']
        })
        const xData = Object.keys(a4_x).sort((a, b) => a -  b).map(i => a4_x[i])
        const yData = Object.keys(a4_y).sort((a, b) => a -  b).map(i => a4_y[i])
        if (this.showType === 'business') {
          const colors = ['4B84E6','6ECFB3','F6CC64','F6695A','755FF6','F6A05D','6AE2D5']
          const len = colors.length
          const arr1 = res[this.text5]?.data_list || []
          const arr2 = res['跟进量']?.data_list || []
          let v1 = 0, v2 = 0
          const list1 = arr1.map((i, j) => {
            const t = i.status_num_all
            const v = i.status_num_one
            const p = (t && v) ? preciseMultiply(preciseDivide(v * 100, t), 1) : 0
            v1 += t
            v2 += v
            return { name: i.school_name, total: t, value: v, progress: p, color: '#' + colors[j%len] }
          })
          this.list1 = list1
          this.total = v2
          this.rate = v1 ? preciseMultiply(preciseDivide(v2 * 100, v1), 1) : 0
          const list3 = arr2.map(i => ({ name: i.school_name, total: i.status_num_all, value: i.status_num_one }))
          this.list3 = list3
        } else {
          const list2 = [
            { name: '转化率', desc: '转化人数', value: 0, total: 0, progress: 0 },
            { name: '跟进率', desc: '跟进人数', value: 0, total: 0, progress: 0 },
            { name: '待跟进率', desc: '待跟进人数', value: 0, total: 0, progress: 0 },
            { name: '无需跟进率', desc: '无需跟进人数', value: 0, total: 0, progress: 0 },
          ]
          list2.forEach(item => {
            const n = item.name
            const t = res[n].status_num_all || 0
            const v = res[n].status_num_one || 0
            const p = (t && v) ? preciseMultiply(preciseDivide(v * 100, t), 1) : 0
            item.total = t
            item.value = v
            item.progress = p
          })
          this.list2 = list2
        }
        const d1 = {
          tooltip: { trigger: 'item' },
          legend: { bottom: '1%', left: 'center' },
          xAxis: { axisLine: { show: false }},
          yAxis: { axisLine: { show: false }},
          series: [
            {
              type: 'pie',
              radius: ['40%', '70%'],
              center: ['50%', '45%'],
              avoidLabelOverlap: false,
              label: { show: false, position: 'center' },
              emphasis: { label: { show: true, fontSize: 20, fontWeight: 'bold' } },
              labelLine: { show: false },
              data: []
            }
          ]
        }
        const option1 = JSON.parse(JSON.stringify(d1))
        const option2 = JSON.parse(JSON.stringify(d1))
        const option4 = {
          tooltip: { show: false },
          grid: { height: '74%', top: '5%' },
          xAxis: {
            data: xData,
            splitArea: { show: true },
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: {
              show: true,
              interval: 0,
              fontSize: 11,
              lineHeight: 16,
              formatter: function(params) {
                let newParamsName = ''   
                const paramsNameNumber = params.length
                const provideNumber = 7
                const rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                if (paramsNameNumber > provideNumber) {
                  for (let p = 0; p < rowNumber; p++) {
                    let tempStr = ''
                    const start = p * provideNumber
                    const end = start + provideNumber
                    if (p == rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber)
                    } else {
                      tempStr = params.substring(start, end) + '\n'
                    }
                    newParamsName += tempStr
                  }
                } else {
                  newParamsName = params
                }   
                return newParamsName
              }
            }
          },
          yAxis: {
            type: 'category',
            data: yData,
            splitArea: { show: true },
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: {
              show: true,
              width: 50,
              overflow: 'break',
              align: 'right',
              fontSize: 11,
              lineHeight: 16
            }
          },
          visualMap: {
            show: false,
            min: 0,
            max: 3,
            calculable: true,
            orient: 'horizontal',
            left: 'center',
            bottom: '15%',
            inRange: { color: ['#EFF1F7', '#C9D0F2', '#8A9AE4', '#5B70D9' ] }
          },
          series: [
            { type: 'heatmap', label: { show: false }, data: [] }
          ]
        }
        option1.series[0].data = data1
        option2.series[0].data = data2
        option4.series[0].data = data4
        
        data1.length && (this.option1 = option1)
        data2.length && (this.option2 = option2)
        data3.length && (this.option3 = option3)
        data4.length && (this.option4 = option4)

        this.$nextTick(() => {
          this.initEChart()
          data1.length && this.chart1?.setOption(option1)
          data2.length && this.chart2?.setOption(option2)
          data3.length && this.chart3?.setOption(option3)
          data4.length && this.chart4?.setOption(option4)
        })
        this.submitLoading = false
      }).finally(() => {
        this.submitLoading = false
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.disposeEChart()
          this.clearEChart()
          setTimeout(() => {
            this.getChartData()
          }, 300);
        }
      })
    },
    handleReset() {
      this.disposeEChart()
      this.clearEChart()
      this.showType = 'init'
      this.$refs.form.resetFields()
    },
  }
}
</script>

<style lang="scss" scoped>
.follow-list {
  margin-bottom: 12rem;
  padding-bottom: 12rem;
  display: flex;
  gap: 20rem;
  overflow-x: auto;
  .item {
    flex-shrink: 0;
    width: calc(14.28% - 17rem);
    padding: 18rem;
    font-size: 11rem;
    background-color: #fff;
    .top {
      margin-bottom: 6rem;
      display: flex;
      justify-content: space-between;
    }
    .img {
      flex-shrink: 0;
      width: 76rem;
      height: 30rem;
      background-image: url('/img/moral/teacher-work/num.png');
      background-size: cover;
    }
    .tips {
      margin-bottom: 6rem;
      color: #666;
    }
    .num {
      font-size: 13rem;
      color: #3D3D3D;
    }
    .txt {
      font-size: 8rem;
      color: #888;
    }
    .name {
      color: #5C5C5C;
    }
  }
}
.board {
  &-wrap {
    display: flex;
    gap: 24rem;
    justify-content: space-between;
    align-items: center;
  }
  &-l {
    flex: 0 0 56%;
  }
  &-r {
    flex: 1;
  }
  &-t {
    display: flex;
    justify-content: space-between;
    gap: 24rem;
    .rate-box {
      width: calc(50% - 12rem);
      height: 223rem;
      color: #666;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        display: flex;
        align-items: center;
        .txt {
          font-size: 17rem;
        }
        .num {
          padding-left: 10rem;
          font-size:28rem;
          color: #3D3D3D;
          font-weight: 600
        }
      }
      .bot {
        position: relative;
        height: 88rem;
        padding-left: 20rem;
        display: flex;
        align-items: center;
        background-color: #F3F9FE;
        border-radius: 8rem;
        &::before { 
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          height: 68rem;
          width: 3rem;
          transform: translateY(-50%);
          background-color: #3989E3;
          border-radius: 8rem;
        }
        .txt {
          font-size: 14rem;
        }
        .num {
          padding-left: 14rem;
          padding-right: 6rem;
          font-size: 20rem;
          font-weight: 600;
          color: #3D3D3D;
        }
        .unit {
          font-size: 11rem;
          color: #888;
        }
      }
    }
  }
  &-title {
    font-size: 20rem;
    color: #333;
    font-weight: 600;
    height: 42rem;
    .line {
      position: relative;
      padding: 0 45rem;
      &::after {
        position: absolute;
        content: '';
        bottom: -14rem;
        left: 0;
        right: 0;
        height: 4rem;
        background: linear-gradient( 90deg, #EFF1F7 0%, #5B70D9 100%);
      }
      &.b::after {
        background: linear-gradient( 63deg, #6487FA 0%, #A4BAFD 100%);
      }
      &.g::after {
        background: linear-gradient( 63deg, #4BBEEB 0%, #6BE1D5 100%);
      }
    }
  }
  &-content { 
    height: 380rem;
  }
}
.chart-box {
  position: relative;
  height: 400rem;
}
.chart-tips {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4%;
  display: flex;
  justify-content: center;
  gap: 18px;
  .item { 
    display: flex;
    align-items: center;
    .c {
      width: 24px;
      height: 14px;
      border-radius: 2px;
    }
    .t {
      margin-left: 6px;
      color: #333;
      font-size: 12px;
    }
  }
}
.school {
  &-warp {
    position: relative;
    padding-right: 130rem;
    width: 100%;
  }
  &-change {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 130rem;
    color: #333;
    font-size: 15rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 40rem;
    .txt {
      margin-bottom: 10rem;
    }
    .num {
      font-size: 24rem;
      font-weight: 600;
    }
    .rate {
      margin-left: 6rem;
    }
  }
  &-list {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 14.8rem;
    overflow-y: auto;
  }
  &-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content { 
      flex: 1;
      .info {
        margin-bottom: 10rem;
        display: flex;
        justify-content: space-between;
      }
      .name {
        font-size: 16rem;
      }
      .num {
        color: #333;
        font-size: 11rem;
      }
      .bg {
        position: relative;
        height: 10rem;
        background-color: #F3F3F3;
        border-radius: 10rem;
      }
      .cur {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        border-radius: 10rem;
        transition: width 0.9s ease-in-out;
      }
    }
    .progress {
      width: 90rem;
      flex-shrink: 0;
      margin-left: 14rem;
      font-size: 24rem;
      font-weight: 600;
    }
  }
}
</style>